import { useUpdateCollectionMutation } from "@/api/api";
import { Button } from "../button";
import { Input } from "../input";
import { Field, FieldLabel } from "../field";
import { useCollection } from "@/api/hooks";
import { ChangeEvent, useState } from "react";

export default function CollectionNameInput() {
  const collection = useCollection();
  const [title, setTitle] = useState<string>(collection?.title || "");
  const [titleForCollectionId, setTitleForCollectionId] = useState(collection?.id);
  const [updateCollection] = useUpdateCollectionMutation();

  if (collection?.id !== titleForCollectionId) {
    setTitleForCollectionId(collection?.id);
    setTitle(collection?.title || "");
  }

  if (!collection) return null;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleSave = () => {
    updateCollection({ id: collection.id, title });
  };

  const titleChanged = (collection?.title || "") !== title;

  return (
    <Field>
      <FieldLabel htmlFor="collectionName" className="uppercase text-[10.5px] tracking-[.08em] font-bold text-muted-foreground">Collection name</FieldLabel>
      <div className="flex gap-2">
        <Input
          id="collectionName"
          type="text"
          placeholder="Max 255 characters"
          value={title}
          onChange={handleChange}
          className="flex-1 font-serif text-[14px]"
          style={{ fontFamily: "var(--font-serif)" }}
        />
        <Button type="button" variant="outline" disabled={!titleChanged} onClick={handleSave}>
          Save
        </Button>
      </div>
    </Field>
  );
}
